<template>
  <div>
    <v-row>
      <v-col>
        <v-btn
          depressed
          block
          min-height="46"
          color="primary"
          class="white--text text-capitalize rounded-md"
          @click="navigateToQuizCreatePage"
        >
          <v-icon class="pe-2">mdi-plus</v-icon>

          {{ $t("quiz.createNewQuiz") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "QuizCreateButton",
  methods: {
    navigateToQuizCreatePage() {
      this.$router.push({ name: "QuizDetails" });
    },
  },
};
</script>
